import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles/Calendar.css";

import vallon from "../medias/png/icons/vallon.png";
import chrono from "../medias/png/icons/chrono.png";
import plat from "../medias/png/icons/plat.png";
import montagne from "../medias/png/icons/montagne.png";

const Calendar = () => {
  const { t } = useTranslation();

  const icons = {
    Vallon: vallon,
    Chrono: chrono,
    Plat: plat,
    Montagne: montagne,
  };

  const [races, setRaces] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const handleRowClick = (raceId) => {
    navigate(`/show-race-detail/${raceId}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchGeneralRaces = async () => {
      try {
        const response = await fetch(`${apiUrl}/races-list`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des courses générales");
        }

        const data = await response.json();
        setRaces(data);
      } catch (error) {
        console.error("Erreur:", error);
      }
    };

    fetchGeneralRaces();
  }, [apiUrl]);

  return (
    <main className="calendar">
      <h1>{t("calendar.title")}</h1>

      <div className="calendar-table">
        <div className="calendar-table-container">
          <table>
            <thead>
              <tr>
                <th>{t("calendar.table.headers.races")}</th>
                <th>{t("calendar.table.headers.date")}</th>
                <th>{t("calendar.table.headers.category")}</th>
                <th>{t("calendar.table.headers.division")}</th>
                <th>{t("calendar.table.headers.courseType")}</th>
                <th>{t("calendar.table.headers.profile")}</th>
                <th>{t("calendar.table.headers.steps")}</th>
              </tr>
            </thead>

            <tbody>
              {races.map((race) => (
                <tr key={race.raceId} onClick={() => handleRowClick(race.raceId)}>
                  <td>
                    <div className="calendar-name-container">
                      <img
                        className="calendar-flag-icon"
                        src={`${process.env.PUBLIC_URL}/flags/${race.country
                          .replace(/ /g, "_")
                          .toLowerCase()}.png`}
                        alt={t("calendar.flagAlt", { country: race.country })}
                        width="20"
                        height="20"
                      />
                      <span>{race.name}</span>
                    </div>
                  </td>

                  <td>{formatDate(race.date_start)}</td>
                  <td>{race.category}</td>
                  <td>{race.division}</td>
                  <td>{race.courseType}</td>

                  <td>
                    {icons[race.profil] ? (
                      <img
                        src={icons[race.profil]}
                        alt={t("calendar.profileAlt", { profile: race.profil })}
                        width="25"
                        height="25"
                      />
                    ) : (
                      race.profil
                    )}
                  </td>

                  <td>{race.step}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default Calendar;
